import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { ActionCard, Flex, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import {
	ConditionInfoScreen,
	ConditionWithInfoScreen,
	shouldShowConditionInfoScreen,
} from '@component/condition_info_screen.component';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { ReceptionConditionInfoScreenFlow } from '@visiba/api-vcs-client-v2';
import { useCallback, useState } from 'react';
import { useBooking, ViewBookingAnalyticActions } from '../../hooks/use_booking';
import { useReasonForVisit } from './use_reason_for_visit';

export function ScreenReasonForVisit() {
	const viewBooking = useBooking();
	const analytic = useAnalyticContext();
	const [infoScreenCondition, setInfoScreenCondition] = useState<ConditionWithInfoScreen | null>(null);
	const showInfoScreen = useCallback((condition: ConditionWithInfoScreen) => setInfoScreenCondition(condition), []);
	const reasonForVisit = useReasonForVisit(showInfoScreen);

	function handleSelectReasonForVisit(item: ConditionWithInfoScreen) {
		return () => {
			if (shouldShowConditionInfoScreen(item, ReceptionConditionInfoScreenFlow.Booking)) {
				showInfoScreen(item);
				return;
			}

			analytic.trackEvent(ViewBookingAnalyticActions.SelectReasonForVisit, `${item.Id}`);
			reasonForVisit.selectReasonForVisit(item.Id);
		};
	}

	if (infoScreenCondition) {
		return (
			<ConditionInfoScreen
				condition={infoScreenCondition}
				flow={ReceptionConditionInfoScreenFlow.Booking}
				onBack={() => setInfoScreenCondition(null)}
				onCancel={() => viewBooking.goToReceptionHome()}
			/>
		);
	}

	return (
		<Flex gap={tokens.spacing.x1_5}>
			<TopBar.Content goBack />

			<Title
				title={withTranslation('View.Booking.ScreenRfv.Title')}
				titleSize='small'
				description={withTranslation('View.Booking.ScreenRfv.Description')}
			/>

			<Spacer vertical={tokens.spacing.x0_5} />

			<Flex gap={tokens.spacing.x1}>
				{viewBooking.getFilteredReasonForVisits().map((item) => (
					<ActionCard.Root key={item.Id} onClick={handleSelectReasonForVisit(item)}>
						<ActionCard.Title>{item.Name}</ActionCard.Title>
					</ActionCard.Root>
				))}
			</Flex>
		</Flex>
	);
}
